{
  "dashboard": {
    "place": {
      "inShift": "Jetzt: {{clinic}} · bis {{end}}",
      "between": "Nächste Anwesenheitszeit: {{clinic}} · {{start}}",
      "beforeFirst": "Heute: {{clinic}} ab {{start}}",
      "done": "Heutige Anwesenheitszeit beendet · {{clinic}}",
      "overlap": "Gleichzeitig in {{count}} Praxen eingeplant",
      "noShiftToday": "Für heute sind keine Anwesenheitszeiten erfasst",
      "noShiftDay": "Für diesen Tag sind keine Anwesenheitszeiten erfasst",
      "noShiftHint": "Ihre Anwesenheitszeiten erfasst die Praxis",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "(weitere Praxen: {{count}})",
      "aria": "Arbeitsort laut Ihren Anwesenheitszeiten"
    },
    "stats": {
      "total": "Termin(e)",
      "waiting": "wartend",
      "completed": "behandelt",
      "cancelled": "abgesagt",
      "aria": "Termine: {{total}}, wartend: {{waiting}}, behandelt: {{completed}}, abgesagt: {{cancelled}}",
      "share": "Anteil: {{amount}}",
      "shareNoFigure": "Anteil"
    },
    "week": {
      "title": "Tag wählen",
      "thisWeek": "Diese Woche",
      "nextWeek": "Nächste Woche",
      "prevWeek": "Letzte Woche",
      "range": "{{from}} bis {{to}}",
      "fullCalendar": "Vollständiger Kalender",
      "backToWeek": "Zurück zur Woche",
      "countAria": "Termine: {{count}}"
    },
    "clinic": {
      "auto": "Automatisch – nach meinen Anwesenheitszeiten",
      "autoSub": "Die Praxis, die Ihre Anwesenheitszeiten für diesen Tag vorsehen",
      "autoBadge": "Automatisch"
    },
    "book": {
      "open": "Neuer Termin",
      "title": "Termin vergeben",
      "clinic": "Praxis",
      "patient": "Patient",
      "searchLabel": "Patient suchen",
      "searchPlaceholder": "Name, Telefon oder nationale ID",
      "searchHint": "Geben Sie mindestens zwei Zeichen ein.",
      "noMatch": "Kein Patient auf Ihrer Liste entspricht dieser Suche.",
      "truncated": "Es werden nur die ersten {{count}} Ergebnisse angezeigt; grenzen Sie die Suche ein.",
      "newPatient": "Neuer Patient",
      "pickExisting": "Aus Patienten wählen",
      "change": "Ändern",
      "name": "Vollständiger Name",
      "phone": "Mobilnummer",
      "nationalId": "Nationale ID (optional)",
      "when": "Datum und Uhrzeit",
      "duration": "Dauer",
      "minutes": "{{count}} Min.",
      "note": "Notiz (optional)",
      "submit": "Termin vergeben",
      "submitRequest": "Zur Bestätigung an die Praxis senden",
      "readOnlyTitle": "Nur Lesezugriff – das Abonnement der Praxis ist abgelaufen",
      "readOnly": "Das Abonnement dieser Praxis ist abgelaufen und ihr Bereich ist schreibgeschützt; dort können keine Termine vergeben oder verschoben werden, bis die Praxis verlängert. Ihre anderen Praxen sind nicht betroffen.",
      "readOnlyOption": "{{name}} (nur Lesezugriff)",
      "needsApprovalTitle": "Bestätigung durch die Praxis erforderlich",
      "needsApproval": "Termine, die Sie in dieser Praxis vergeben, werden erst verbindlich, wenn der Empfang sie bestätigt; bis dahin lautet ihr Status „Bestätigung der Praxis ausstehend“.",
      "booked": "Der Termin wurde vergeben.",
      "requested": "Der Termin wurde der Praxis zur Bestätigung gesendet.",
      "loadFailed": "Ihre Praxen konnten nicht geladen werden.",
      "noClinic": "Sie können derzeit in keiner Praxis Termine vergeben.",
      "searchFailed": "Die Patientensuche ist fehlgeschlagen.",
      "modeFirstDay": "Erster freier Termin",
      "modeFirstToday": "Erster freier Termin heute",
      "modeManual": "Uhrzeit wählen",
      "showTimeOptions": "Tag oder Art der Zeitwahl ändern",
      "hideTimeOptions": "Zeitoptionen ausblenden",
      "noneLeftToday": "Heute gibt es keine freien Termine mehr.",
      "finding": "Nächster freier Termin wird gesucht…",
      "bookThisOne": "Diesen Termin vergeben",
      "firstFree": "Erster freier Termin",
      "exactAtBooking": "Die genaue Uhrzeit wird beim Vergeben festgelegt.",
      "firstSlotFailed": "Der nächste freie Termin konnte nicht ermittelt werden. Sie können die Uhrzeit selbst wählen.",
      "lessOptions": "Weitere Optionen ausblenden",
      "typeInPerson": "Vor Ort",
      "typeOnline": "Online",
      "submitFirst": "Ersten freien Termin vergeben",
      "walkIn": "Sofort, ohne Uhrzeit",
      "walkInOff": "Der Patient ist jetzt da; ohne Uhrzeit in das heutige Wartezimmer aufnehmen.",
      "walkInOn": "Ohne Uhrzeit vergeben; der Patient kommt jetzt in das heutige Wartezimmer.",
      "walkInOnShort": "Ohne Uhrzeit; kommt in das heutige Wartezimmer.",
      "walkInLead": "Heute sind keine Termine mehr frei; nehmen Sie den Patienten jetzt ohne Uhrzeit in das heutige Wartezimmer auf.",
      "walkInLeadShort": "Ohne Uhrzeit, heutiges Wartezimmer.",
      "walkInNoGrant": "In dieser Praxis warten Ihre Termine auf die Bestätigung durch den Empfang; einen bereits anwesenden Patienten nimmt der Empfang der Praxis auf.",
      "walkInNoGrantShort": "In dieser Praxis kann nur der Empfang Patienten ohne Uhrzeit aufnehmen.",
      "alreadyOpen": {
        "scheduled": "Dieser Patient hat heute bereits einen weiteren Termin und ist noch nicht eingetroffen.",
        "arrived": "Dieser Patient ist bereits im heutigen Wartezimmer – ist ein zweiter Termin nötig?",
        "in_visit": "Dieser Patient ist gerade in Behandlung – ist ein zweiter Termin nötig?"
      },
      "submitWalkIn": "Ins Wartezimmer aufnehmen",
      "walkInBooked": "Der Patient wurde in das heutige Wartezimmer aufgenommen.",
      "mode": "Art der Zeitwahl",
      "day": "Tag",
      "visitType": "Konsultationsart",
      "moreOptions": "Weitere Optionen (Konsultationsart, Dauer, Notiz)",
      "noneThisDay": "An diesem Tag haben Sie keinen freien Termin.",
      "nextIs": "Ihr nächster freier Termin:",
      "noneIn30Days": "Auch in den nächsten 30 Tagen wurde kein freier Termin gefunden.",
      "slotAt": "{{date}}, {{time}}",
      "errors": {
        "clinic": "Wählen Sie eine Praxis.",
        "patient": "Wählen Sie einen Patienten.",
        "name": "Geben Sie den Namen des Patienten ein.",
        "phone": "Diese Mobilnummer ist ungültig.",
        "nationalId": "Diese nationale ID ist ungültig.",
        "when": "Geben Sie Datum und Uhrzeit ein.",
        "past": "Dieser Zeitpunkt liegt bereits in der Vergangenheit.",
        "noSlot": "An diesem Tag gibt es keinen freien Termin; wählen Sie einen anderen Tag oder geben Sie die Uhrzeit selbst ein.",
        "phoneShared": "Diese Nummer hat weitere Akten; wählen Sie eine aus oder tippen Sie auf „Neuer Patient mit dieser Nummer“."
      },
      "searchPickClinic": "Wählen Sie zuerst eine Praxis, um ihre Patienten zu suchen.",
      "phoneCandidates": {
        "title": "Diese Nummer ist bereits in Akten eingetragen: {{count}}",
        "hint": "Ist die Person vor Ihnen eine davon? Wählen Sie sie aus. Ist es jemand anderes mit derselben Nummer (etwa ein Familienmitglied), tippen Sie auf „Neuer Patient mit dieser Nummer“.",
        "choose": "Auswählen",
        "sharedNote": "Ein neuer Patient wird mit einer Nummer angelegt, die bereits in anderen Akten steht.",
        "showAgain": "Akten anzeigen",
        "inClinic": "In der Liste dieser Praxis",
        "conflictOnSubmit": "Diese Nummer wurde soeben in einer anderen Akte eingetragen; prüfen Sie die Liste.",
        "lookupFailed": "Die Akten zu dieser Nummer konnten nicht geprüft werden. Bitte versuchen Sie es erneut.",
        "checking": "Akten dieser Nummer werden geprüft…",
        "checkFailed": "Die Akten dieser Nummer konnten nicht geprüft werden; beim Buchen wird erneut geprüft."
      }
    },
    "phones": {
      "more": "Weitere Nummern: {{count}}",
      "otherLine": "{{relation}}: {{phone}}"
    },
    "withdraw": {
      "action": "Anfrage zurückziehen",
      "title": "Terminanfrage zurückziehen",
      "message": "Terminanfrage für {{name}} zurückziehen? Die Anfrage wird aus der Liste der Praxis entfernt.",
      "confirm": "Anfrage zurückziehen",
      "keep": "Zurück",
      "failed": "Die Anfrage konnte nicht zurückgezogen werden."
    },
    "reschedule": {
      "current": "Bisheriger Termin: {{when}}",
      "newTime": "Neue Zeit",
      "hint": "Der Termin wird verschoben, nicht abgesagt und neu vergeben; Rechnung und Zahlung bleiben daher unverändert.",
      "moved": "Der Termin wurde auf {{when}} verschoben."
    },
    "edit": {
      "untimedCurrent": "Außer der Reihe — noch ohne Uhrzeit",
      "setTimeHint": "Legen Sie die Uhrzeit dieses Termins fest; der Patient erhält keine Nachricht.",
      "action": "Termin bearbeiten",
      "title": "Termin bearbeiten",
      "submit": "Änderungen speichern",
      "type": "Art des Besuchs",
      "inPerson": "Vor Ort",
      "online": "Online",
      "typeHint": "Nur die Art des Besuchs ändert sich; der Preis bleibt wie gebucht.",
      "typeLocked": {
        "over": "Dieser Besuch ist abgeschlossen; seine Art lässt sich nicht mehr ändern.",
        "notConfigured": "Online-Besuche sind in diesem System nicht aktiviert."
      },
      "timeLocked": {
        "status": "Nur ein Termin, der noch auf seinen Patienten wartet, kann verschoben werden; dieser Patient ist bereits da oder der Besuch hat begonnen.",
        "grant": "In dieser Klinik werden Ihre Termine vom Empfang bestätigt; das Verschieben überlassen Sie dem Empfang der Klinik.",
        "untimed": "Dies ist ein Termin ohne feste Uhrzeit, daher gibt es keine Zeit zu ändern."
      },
      "note": "Terminnotiz"
    },
    "rowOps": {
      "more": "Weitere Aktionen für {{name}}",
      "next": "Als Nächste/n aufrufen",
      "backToRoom": "Zurück ins Sprechzimmer",
      "note": "Terminnotiz",
      "nextAppt": "Nächster Termin",
      "noShow": "Nicht erschienen",
      "cancel": "Termin absagen",
      "cancelled": "Der Termin von {{name}} wurde abgesagt.",
      "cancelTitle": "Termin absagen",
      "cancelMessage": "Der Termin von {{name}} um {{time}} wird abgesagt. Das lässt sich nicht rückgängig machen.",
      "cancelConfirm": "Ja, absagen",
      "noShowTitle": "Nichterscheinen erfassen",
      "noShowMessage": "Der Termin von {{name}} um {{time}} wird als nicht erschienen erfasst.",
      "noShowConfirm": "Nichterscheinen erfassen",
      "noteTitle": "Terminnotiz",
      "noteLabel": "Notiz zum Termin von {{name}}",
      "noteHint": "Der Empfang der Praxis sieht diese Notiz ebenfalls. Leer lassen, um sie zu löschen.",
      "noteSave": "Notiz speichern",
      "errors": {
        "hasPayment": "Für diesen Termin wurde bereits bezahlt; die Absage übernimmt der Empfang.",
        "needsGrant": "In dieser Praxis übernimmt der Empfang Absagen und das Erfassen von Nichterscheinen.",
        "paymentCheck": "Der Zahlungsstatus dieses Termins konnte nicht geprüft werden; bitte erneut versuchen.",
        "readOnly": "Das Abonnement dieser Praxis ist abgelaufen und ihr Bereich ist schreibgeschützt; diese Änderung muss bis zur Verlängerung warten.",
        "gone": "Diesen Termin gibt es nicht mehr; die Liste wurde aktualisiert.",
        "next": "Der Patient konnte nicht als Nächster gesetzt werden.",
        "cancel": "Der Termin konnte nicht abgesagt werden.",
        "noShow": "Das Nichterscheinen konnte nicht erfasst werden.",
        "note": "Die Notiz konnte nicht gespeichert werden."
      }
    }
  },
  "nav": {
    "mobile": {
      "more": "Mehr",
      "moreTitle": "Mehr",
      "account": "Konto",
      "sections": "Bereiche",
      "balance": "{{coin}}-Guthaben"
    }
  }
}
